var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{class:{'step': true, 'step-active': _vm.isActive, 'step-disabled': _vm.isDisabled},on:{"click":function($event){return _vm.toStep(_vm.$props.step)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }